import { Box, Typography } from '@mui/material';
import { IconLockCheck } from '@tabler/icons-react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

export const EncryptedMessage = observer(() => {
  const { t } = useTranslation('common');
  return (
    <Box
      sx={{
        bgcolor: 'info.light',
        p: 1,
        borderRadius: 1,
        display: 'flex',
        width: 1,
        justifyContent: 'center',
        alignItems: 'center',
        whiteSpace: 'pre-line',
        gap: 1,
      }}
    >
      <Box sx={{ color: 'info.main', display: 'flex', alignItems: 'center' }}>
        <IconLockCheck />
      </Box>
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: '12px',
          lineHeight: 1.1,
          color: 'info.dark',
        }}
      >
        {t('encrypted')}
      </Typography>
    </Box>
  );
});
